import InspectionResultBox from "./InspectionResultBox";

export default InspectionResultBox;
